/**
 * useRenderMode — Determines how pages should render their UI
 *
 * 'desktop' → full UniversalGrid, multi-tab, sidebar (web-client)
 * 'mobile'  → card list, bottom sheet forms, compact layout (go-pwa / extension-shell)
 *
 * Usage:
 *   const mode = useRenderMode();
 *   if (mode === 'mobile') return <MobileCardList ... />;
 *   return <UniversalGrid ... />;
 */

import { createContext, useContext } from 'react';

export type RenderMode = 'desktop' | 'mobile';

export const RenderModeContext = createContext<RenderMode>('desktop');

export function useRenderMode(): RenderMode {
  return useContext(RenderModeContext);
}
